import BlockIcon from '@mui/icons-material/Block';
import React, { FC } from 'react';
import { LinkifiedText } from 'src/components/common/LinkifiedText/LinkifiedText';
import { Comment } from 'src/api/comments';
import styles from '../CommentItem.module.scss';

interface CommentContentProps {
  comment: Comment;
  isEditing: boolean;
  editedText: string;
  setEditedText: React.Dispatch<React.SetStateAction<string>>;
  videoRef: React.RefObject<HTMLVideoElement>;
  handleVideoClick: () => void;
  handleSaveEdit: () => void;
}

export const CommentContent: FC<CommentContentProps> = ({
  comment,
  isEditing,
  editedText,
  setEditedText,
  videoRef,
  handleVideoClick,
  handleSaveEdit,
}) => {
  return (
    <div className={styles.commentContent}>
      {comment.is_deleted ? (
        <div className={styles.deletedComment}>
          <BlockIcon className={styles.deletedIcon} />
          <span className={styles.deletedText}>Comment has been deleted</span>
        </div>
      ) : isEditing ? (
        <div className={styles.inputWrapper}>
          <input
            type="text"
            className={styles.commentInput}
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            placeholder="Edit your comment"
          />
          <div className={styles.postButton} onClick={handleSaveEdit}>
            Save
          </div>
        </div>
      ) : (
        <>
          {comment.text && (
            <p className={styles.commentText}>
              <LinkifiedText text={comment.text} />
            </p>
          )}
          {comment.media_type === 'image' && (
            <img
              src={comment.media_url || ''}
              alt="Comment media"
              className={styles.commentImage}
            />
          )}
          {comment.media_type === 'video' && (
            <video
              ref={videoRef}
              controls
              onClick={handleVideoClick}
              className={styles.commentVideo}
            >
              Your browser does not support the video tag.
            </video>
          )}
        </>
      )}
    </div>
  );
};
